import React, {forwardRef} from "react";
import Scrollbars from "react-custom-scrollbars-2";

const ResponsiveScrollbars = forwardRef(({onScroll, style, children}, ref) => {
    return (
        <Scrollbars className="responsive-list-scrollbar" onScroll={onScroll} style={style} ref={ref}>
            {children}
        </Scrollbars>
    );
});

export default ResponsiveScrollbars